import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { checkoutMessages } from './index';

export const PaymentCTA = ({ orderTotal, couponApplied, ctaLabel }) => {
  if (couponApplied && orderTotal === 0) {
    return <FormattedMessage {...checkoutMessages.completeOrder} />;
  }

  if (ctaLabel) {
    return <>{ctaLabel}</>;
  }

  return <FormattedMessage {...checkoutMessages.payNow} />;
};

PaymentCTA.propTypes = {
  orderTotal: PropTypes.number,
  couponApplied: PropTypes.bool,
  ctaLabel: PropTypes.string,
};
